<template>
  <div class="certificate_page">
    <div class="certificate_item" v-for="(item, index) in certificateList" :key="index">
      <h3>{{ item.certificateName }}</h3>
      <img src="../../../assets/image/certificateBg.jpg" alt="" style="width: 100%" />
      <div class="bottom_btn">
        <a-button type="primary" @click="previewFile(index)" :loading="ispreviewFile"> 查看详情 </a-button>
        <a-button type="primary" @click="downloadFile(index)" :loading="isdownloadFile"> 下载 </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getCertificateList, getCertificateInfo } from '../../../api/course'
import axios from 'axios'
export default {
  data() {
    return {
      certificateList: [],
      ispreviewFile: false,
      isdownloadFile: false,
    }
  },
  mounted() {
    this.get_lis()
  },
  methods: {
    previewFile(index) {
      this.ispreviewFile = true
      let params = { id: this.certificateList[index].id }
      let baseUrl = process.env.VUE_APP_API_BASE_URL
      axios.defaults.headers['token'] = this.$store.getters.token
      axios({
        url: baseUrl + '/training/training/certificate/downloadCertificate',
        method: 'get',
        responseType: 'arraybuffer',
        params: params,
      })
        .then((res) => {
          this.ispreviewFile = false
          if (res.data.code && res.data.code != 200) {
            return this.$message.error(res.data.msg)
          }
          const content = res.data
          const blob = new Blob([content], { type: 'application/pdf' })
          let a = new FileReader()
          const elink = document.createElement('a')
          elink.target = '_blank'
          elink.style.display = 'none'
          elink.href = window.URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          window.URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        })
        .catch((err) => {
          this.ispreviewFile = false
          console.log(err)
        })
    },
    downloadFile(index) {
      this.isdownloadFile = true
      let params = { id: this.certificateList[index].id }
      let baseUrl = process.env.VUE_APP_API_BASE_URL
      axios.defaults.headers['token'] = this.$store.getters.token
      axios({
        url: baseUrl + '/training/training/certificate/downloadCertificate',
        method: 'get',
        responseType: 'arraybuffer',
        params: params,
      })
        .then((res) => {
          this.isdownloadFile = false
          if (res.data.code && res.data.code != 200) {
            return this.$message.error(res.data.msg)
          }
          const content = res.data
          const blob = new Blob([content], { type: 'application/pdf' })
          var timestamp = new Date().valueOf()
          const fileName = timestamp + '.pdf'
          if ('download' in document.createElement('a')) {
            // 非IE下载
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = window.URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            window.URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    get_lis() {
      getCertificateList().then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.certificateList = res.data
      })
    },
  },
}
</script>

<style lang="less" scoped>
.certificate_page {
  width: 100%;
  max-height: 100%;
  padding: 8px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  overflow-y: auto;
  .certificate_item {
    margin: 0 10px 10px 0;
    padding: 20px 10px;
    border-radius: 8px;
    box-shadow: 0px 2px 10px 0px rgba(87, 107, 176, 0.3);
    width: 240px;
    > img {
      margin: 8px 0;
    }
    .bottom_btn {
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }
}
</style>